import { Link, useLocation, useNavigate } from 'react-router-dom';

function PublicNavbar() {
  const location = useLocation();
  const navigate = useNavigate();

  // Features/Pricing/Contact are sections on the home page. When already on "/",
  // scroll to them directly; otherwise (e.g. on /events) navigate home and let
  // Home scroll to the section on mount, since those IDs don't exist elsewhere.
  const goToSection = (sectionId) => (e) => {
    e.preventDefault();
    if (location.pathname === '/') {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: sectionId } });
    }
  };

  return (
    <nav className="bg-white shadow-sm fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Link to="/" className="flex items-center">
              <img 
                src="/assets/images/logo.svg" 
                alt="Member Hub Logo"
                className="w-8 h-8 sm:w-10 sm:h-10 md:w-12 md:h-12 mr-3"
              />
              <span className={`text-lg sm:text-xl font-bold ${window.location.hostname === 'members-staging.research-triangle.ai' ? 'text-red-600' : 'text-gray-900'}`}>Member Hub</span>
            </Link>
          </div>

          {/* Navigation Links */}
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <Link to="/events" className="text-gray-600 hover:text-blue-600 px-3 py-2 text-sm font-medium transition duration-150">
                Events
              </Link>
              <a href="/#features" onClick={goToSection('features')} className="text-gray-600 hover:text-blue-600 px-3 py-2 text-sm font-medium transition duration-150">
                Features
              </a>
              <a href="/#pricing" onClick={goToSection('pricing')} className="text-gray-600 hover:text-blue-600 px-3 py-2 text-sm font-medium transition duration-150">
                Pricing
              </a>
              <a href="/#contact" onClick={goToSection('contact')} className="text-gray-600 hover:text-blue-600 px-3 py-2 text-sm font-medium transition duration-150">
                Contact
              </a>
            </div>
          </div>

          {/* Auth Buttons */}
          <div className="flex items-center space-x-4">
            <Link
              to="/login"
              className="text-gray-600 hover:text-blue-600 px-3 py-2 text-sm font-medium transition duration-150"
            >
              Sign In
            </Link>
            <Link
              to="/register"
              className="bg-blue-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-blue-700 transition duration-150"
            >
              Join Now
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button
              type="button"
              className="bg-white p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-blue-500"
              aria-expanded="false"
            >
              <span className="sr-only">Open main menu</span>
              <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default PublicNavbar;